/**
 * Created by tofael on 12/14/17.
 */

import React from 'react';
import Avatar from 'material-ui/Avatar';
import Divider from 'material-ui/Divider';
import Subheader from 'material-ui/Subheader';
import {List, ListItem} from 'material-ui/List';
import config from '../../utility/app-config';
import utils from '../../utility/utils';
import globalStyles from '../../utility/styles';

const styles = {
  root: {

  },
  item: {
    height: '50px',
    padding: '5px',
    cursor: 'pointer',
    marginBottom: '10px'
  },
  header: {
    width: 'inherit',
    margin: '0px -10px 0px -8px'
  },
  text: {
    margin: '8px',
    height: '20px',
    color: '#000000',
    fontSize: '15px',
    marginLeft: '10px',
  },
  history: {
    fontSize: '15px',
    color: '#080808',
    fontWeight: 'bold',
    marginTop: '10px',
    marginBottom: '5px'
  },
  date:{
    fontSize: '12px',
    color: '#070707'
  },
};

const PrescriptionList = ({prescriptionList, displayPrescriptionDialog, className, style}) => {
  return (
    <div className={className} style={{...styles.root, ...style}}>
      {
        prescriptionList.length > 0 &&
        <Subheader style={globalStyles.subheader}>Mission Prescription (s)</Subheader>
      }
      <List>
        {
          [].concat(prescriptionList)
            .sort((a, b)=>{
              return Date.parse(b.created_at) - Date.parse(a.created_at);
            })
            .map((prescription, index) => (
              <div key={index}>
                <div style={styles.text}>
                  <span>Prescription Number: </span>
                  <span>{prescription.prescription_number}</span>
                </div>
            {
              prescription.file_data && prescription.file_data.map((data,ind) => (
                <ListItem
                  key={ind}
                  style={styles.item}
                  leftAvatar={<Avatar size={30} src={`${config.urls.doc_url}${data.s3_key}`}/>}
                  primaryText={`Uploaded at ${utils.toAppDate(prescription.created_at)}`}
                  onTouchTap={displayPrescriptionDialog.bind(null, prescription)}
                />
              ))           
            }
            { 
               (!prescription.file_data && prescription.s3_key) &&
                <ListItem
                  key={index}
                  style={styles.item}
                  leftAvatar={<Avatar size={30} src={`${config.urls.doc_url}${prescription.s3_key}`}/>}
                  primaryText={`Uploaded at ${utils.toAppDate(prescription.created_at)}`}
                  onTouchTap={displayPrescriptionDialog.bind(null, prescription)}
                />
            }
            { 
              (!prescription.file_data && prescription.additional_s3_keys) && 
                prescription.additional_s3_keys.map((img,ind) => (
                <ListItem
                  key={ind}
                  style={styles.item}
                  leftAvatar={<Avatar size={30} src={`${config.urls.doc_url}${img}`}/>}
                  primaryText={`Uploaded at ${utils.toAppDate(prescription.created_at)}`}
                  onTouchTap={displayPrescriptionDialog.bind(null, prescription)}
                />
              ))
            }
                <Divider/>
              </div>
            ))
        }
      </List>
      {/*<div>*/}
      {/*{*/}
      {/*prescriptionList.map((prescription, index) => (*/}
      {/*<div onClick={displayPrescriptionDialog.bind(null,prescription)} key={index} style={styles.item}>*/}
      {/*<div style={styles.date}>{utils.toAppDate(prescription.created_at)}</div>*/}
      {/*<Divider inset={false} />*/}
      {/*</div>*/}
      {/*))*/}
      {/*}*/}
      {/*</div>*/}
    </div>
    )
};

export default PrescriptionList;


// WEBPACK FOOTER //
// ./src/screens/mission-view/prescription-list.js